module.exports = __webpack_public_path__ + "img/manage10.f584568a.png";